import api from '../../services/api';
import { useState, useEffect } from "react";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import HealthAndSafetyOutlinedIcon from '@mui/icons-material/HealthAndSafetyOutlined';
import Pagination from '@mui/material/Pagination';
import Box from '@mui/material/Box';
import PageContainer from '../../common/components/PageContainer';
import PageHeader from '../../common/components/PageHeader';
import EntityCardGrid from '../../common/components/EntityCardGrid';
import EntityCard from '../../common/components/EntityCard';
import usePermissoes from '../../common/hooks/usePermissoes';
import Permissoes from '../../common/permissoes';

function EPI() {
    const { hasPermission } = usePermissoes();
    const [textoPesquisa, setTextoPesquisa] = useState("");
    const [data, setData] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);

    useEffect(() => {
        async function fetchData() {
            try {
                const response = await api.get(`/epi/pesquisa?texto=${textoPesquisa}&page=${page - 1}`);
                setData(response.data.content);
                setTotalPages(response.data.page.totalPages);
            } catch (error) {
                console.error("Erro ao buscar dados dos EPIs:", error);
            }
        }
        fetchData();
    }, [page, textoPesquisa]);

    const handleChange = (event, value) => {
        setPage(value);
    };

    return (
        <PageContainer>
            <PageHeader
                title="EPIs"
                searchValue={textoPesquisa}
                onSearchChange={(e) => {
                    setPage(1);
                    setTextoPesquisa(e.target.value);
                }}
                actionLabel={hasPermission(Permissoes.EPI_CADASTRO) ? "Adicionar EPI" : undefined}
                actionIcon={<AddCircleOutlineIcon />}
                actionTo="/epi/cadastro"
            />

            <EntityCardGrid
                items={data}
                keyExtractor={(epi) => epi.id}
                emptyMessage="Nenhum EPI encontrado."
                renderItem={(epi) => (
                    <EntityCard
                        to={`/epi/${epi.id}`}
                        image={epi.foto ? `data:image/jpeg;base64,${epi.foto}` : null}
                        icon={<HealthAndSafetyOutlinedIcon fontSize="inherit" />}
                        title={epi.nome}
                        subtitle={`Qtd: ${epi.estoque} UN${epi.ca ? ` · CA: ${epi.ca}` : ''}`}
                    />
                )}
            />

            {totalPages > 1 && (
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
                    <Pagination count={totalPages} page={page} onChange={handleChange} color="primary" />
                </Box>
            )}
        </PageContainer>
    );
}

export default EPI;
